import React, { Component } from "react";
import { connect } from "react-redux";
import { Nav, NavItem, NavLink, Button, Input, Label, Form } from "reactstrap";
import ExtratoConta from "../usuario/perfil/extratoConta";
import {
  getPaymentsMade,
  requestWithdraw,
  getPaymentsReceived
} from "../../providers/paymentProvider";
import Toast from "../utils/Toast";
import WithdrawsHistory from "./WithdrawsHistory";
import BankInfo from "./BankInfo";

const tabs = {
  bankInfo: 0,
  creditCards: 1,
  configurations: 2,
  withdrawsHistory: 3
};

class ProfessionalFinanceOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: tabs.bankInfo,
      paymentsMade: [],
      paymentsReceived: [],
      withdraw: 0,
      successMessage: "",
      errorMessage: ""
    };
  }

  async componentDidMount() {
    //this.getPaymentsMade();
    this.getPaymentsReceived();
  }

  getPaymentsMade = async () => {
    const { taxpayer } = this.props.profile;
    if (!taxpayer) return;

    const payments = await getPaymentsMade(taxpayer);
    console.log(payments);
    if (payments.error) {
      return;
    }
    this.setState({ paymentsMade: payments.result.results });
  };

  getPaymentsReceived = async () => {
    const result = await getPaymentsReceived(
      this.props.userInfo._id,
      this.props.userInfo.token
    );
    console.log(result);
    if (result.error) {
      return;
    }
    this.setState({ paymentsReceived: result.result });
  };

  sendWithdrawRequest = async () => {
    const { withdraw } = this.state;
    const { credits } = this.props.userInfo;

    if (credits < 100) {
      this.setState({
        errorMessage:
          "É necessário ter pelo menos 100,00 C$ de saldo para solicitar saque"
      });
      setTimeout(() => this.setState({ errorMessage: "" }), 200);
      return;
    }
    if (withdraw > credits) {
      this.setState({ errorMessage: "Saldo insuficiente" });
      setTimeout(() => this.setState({ errorMessage: "" }), 200);
      return;
    }
    if (withdraw < 100) {
      this.setState({
        errorMessage: "O valor mínimo a ser sacado é de 100,00 C$"
      });
      setTimeout(() => this.setState({ errorMessage: "" }), 200);
      return;
    }

    console.log(withdraw);
    const result = await requestWithdraw(
      this.props.userInfo._id,
      Number(withdraw),
      this.props.userInfo.token
    );
    if (result && result.error) {
      //show error message
      this.setState({
        errorMessage: "Erro ao solicitar saque, tente novamente"
      });
      setTimeout(() => this.setState({ errorMessage: "" }), 200);
      return;
    }
    //show success message
    this.setState({ successMessage: "Solicitação enviada" });
  };

  renderStatement() {
    return <ExtratoConta payments={this.state.paymentsMade} />;
  }

  renderWithdrawsHistory() {
    return <WithdrawsHistory payments={this.state.paymentsReceived} />;
  }

  renderConfigurations() {
    return (
      <React.Fragment>
        <h3>Solicitar saque</h3>
        <p>
          Saldo:{" "}
          {`${Number(this.props.userInfo.credits).toFixed(2)}`.replace(
            ".",
            ","
          )}{" "}
          C$
        </p>
        <Label>
          Quantia a ser recebida:
          <Input
            type="number"
            value={this.state.withdraw}
            onChange={e => this.setState({ withdraw: e.target.value })}
          />
        </Label>
        <br />
        <Button onClick={this.sendWithdrawRequest}>Solicitar</Button>
      </React.Fragment>
    );
  }

  renderBankInfo() {
    const {
      holderName,
      accountTaxPayer,
      bankAccount,
      bankAgency
    } = this.props.professionalInfo;

    const accountInfo = {
      holderName,
      accountTaxPayer,
      bankAccount,
      bankAgency
    };
    return <BankInfo accountInfo={accountInfo} user={this.props.userInfo} />;
  }

  renderContent() {
    switch (this.state.activeTab) {
      case tabs.withdrawsHistory:
        return this.renderWithdrawsHistory();
      case tabs.configurations:
        return this.renderConfigurations();
      case tabs.bankInfo:
        return this.renderBankInfo();
    }
  }

  isActive(tab) {
    let className = null;
    if (tab === this.state.activeTab) {
      className = "active";
    }
    return className;
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="mt-4">
          <h2 id="tipo-texto">Opções Financeiras</h2>
        </div>
        <Nav className="nav-account-content">
          <NavItem>
            <NavLink
              className={this.isActive(tabs.bankInfo)}
              href="#"
              onClick={() => this.setState({ activeTab: tabs.bankInfo })}
            >
              Informações bancárias
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={this.isActive(tabs.withdrawsHistory)}
              href="#"
              onClick={() =>
                this.setState({ activeTab: tabs.withdrawsHistory })
              }
            >
              Histórico de saques
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={this.isActive(tabs.configurations)}
              href="#"
              onClick={() => this.setState({ activeTab: tabs.configurations })}
            >
              Saldo da conta
            </NavLink>
          </NavItem>
        </Nav>
        <div>
          <div className="profile-card">{this.renderContent()}</div>
        </div>
        {this.state.successMessage ? (
          <Toast message={this.state.successMessage} type="success" />
        ) : null}
        {this.state.errorMessage ? (
          <Toast message={this.state.errorMessage} type="error" />
        ) : null}
      </div>
    );
  }
}

//export default FinanceOptions;

const mapStateToProps = state => {
  return {
    professionalInfo: state.user.userInfo.professionalInfo,
    userInfo: state.user.userInfo
  };
};
export default connect(mapStateToProps)(ProfessionalFinanceOptions);
